import React from "react";
import { useRouter } from "next/router";

import Head from "next/head";

import { NextSeo } from "next-seo";
import CanvasScriptLoader from "@/components/canvas/CanvasScriptLoader";

interface IDetailValues {
  uid: string;
  strategyData: any;
  nudge: boolean;
  token: string;
}

const page: any = (props: IDetailValues) => {
  const generateScriptCode = () => {
    return {
      token: "",
      user_id: "4VXr2i",
      user_name: "Anonymous",
      demo_mode: true,
      unique_id: "9cf4d5d9-15e1-45d4-8f8f-289f10eb1444",
      logoVisible: false,
    };
  };

  const main = () => {
    return (
      <>
        <div className="mx-auto relative">
          <div
            id="canvas-root"
            style={{ position: "relative" }}
            className="prevent-select"
          ></div>
          <CanvasScriptLoader
            config={generateScriptCode()}
          ></CanvasScriptLoader>
        </div>
      </>
    );
  };

  return (
    <>
      <NextSeo
        title={"Try Level2"}
        description={
          "Join TryLevel2, the ultimate no-code trading platform designed for traders of all levels. Create, automate, and optimize your trading strategies effortlessly using our intuitive drag-and-drop interface. Gain access to powerful tools, robust and high performance APIs, and risk management features that will elevate your trading game. Don’t miss out on our 30-day free trial—sign up now to explore all our features and start trading smarter!"
        }
      />
      <Head>
        <link rel="stylesheet" href="/canvas/edit/new/level2-index.css" />
      </Head>
      {main()}
    </>
  );
};

export default page;
